import { StyleSheet } from 'aphrodite';
import {
	brandPrimary,
	brandPrimaryText,
	brandSecondary,
	kitTintColor,
	noteTintColor,
	success,
} from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	bottomRow: {
		display: 'flex',
		height: 100,
		justifyContent: 'space-between',
		padding: '15px 0',
		width: '100%',
	},
	breakItDown: {
		background: brandPrimary,
		borderRadius: 10,
		height: 56,
		margin: '30px 0 10px',
		textAlign: 'center',
		width: 250,
	},
	breakItDownText: {
		color: '#FFF',
		fontSize: 18,
		fontWeight: 'bolder',
		letterSpacing: 1.8,
		padding: '0 16px',
		textDecoration: 'underline',
		textTransform: 'uppercase',
	},
	colorGreen: {
		color: success,
	},
	colorLightBlue: {
		color: brandSecondary,
	},
	colorOrange: {
		color: kitTintColor,
	},
	colorRed: {
		color: '#F9A1AC',
	},
	colorYellow: {
		color: noteTintColor,
	},
	container: {
		background: brandPrimaryText,
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		display: 'flex',
		height: 315,
		width: '100%',
	},
	industry: {
		fontSize: 16,
		fontWeight: 900,
		letterSpacing: 1.6,
		margin: '6px 0',
		textTransform: 'uppercase',
	},
	leftSection: {
		margin: 30,
		minWidth: 600,
		width: '60%',
	},
	percent: {
		color: '#FFFFFF',
		fontSize: 30,
		fontWeight: 'bold',
		paddingTop: 44,
	},
	percentLarge: {
		color: '#FFFFFF',
		fontSize: 72,
		fontWeight: 'bold',
	},
	percentSmall: {
		color: '#FFF',
		marginLeft: 5,
	},
	rightSection: {
		transform: 'translateY(25px)',
		width: '30%',
	},
	title: {
		fontSize: 13,
		fontWeight: 900,
		letterSpacing: '1.2px',
		textTransform: 'uppercase',
	},
	topRow: {
		display: 'flex',
		height: 100,
		justifyContent: 'space-between',
		width: '100%',
	},
	valueColumn: {
		textAlign: 'center',
	},
});
